export type MenuItemsData = {
  step: number;
  name: string;
};

export const menuItems: MenuItemsData[] = [
  {
    step: 1,
    name: 'Local do abastecimento',
  },
  {
    step: 2,
    name: 'Preenchimento',
  },
  {
    step: 3,
    name: 'Resumo do pedido',
  },
  {
    step: 4,
    name: 'Conclusão',
  },
];

export const menuMobileItems: MenuItemsData[] = [
  {
    step: 1,
    name: 'Local do abastecimento',
  },
  {
    step: 2,
    name: 'Preenchimento',
  },
  {
    step: 3,
    name: 'Resumo do pedido',
  },
  {
    step: 4,
    name: 'Conclusão',
  },
];

/** Steps nomeados do fluxo (evita literais mágicos / acoplamento a length). */
export const STEP = {
  BASES: 1,
  FILL: 2,
  SUMMARY: 3,
  DONE: 4,
} as const;
